
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[province]/discover/[tour]/[[...scene]]",
      function () {
        return require("private-next-pages/[province]/discover/[tour]/[[...scene]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[province]/discover/[tour]/[[...scene]]"])
      });
    }
  